(ns teamoesterreich.admin-mode.user.user-card-devices
  (:require ["react-virtualized" :as rv]
            [clojure.string]
            [reagent.core :as r]
            [reagent-material-ui.components :as mui]
            [goog.date.DateTime]
            [teamoesterreich.util.log :as log]
            [reagent-material-ui.cljs-time-utils :refer [cljs-time-utils]]

            [reagent-material-ui.icons.cancel :refer [cancel]]
            [reagent-material-ui.icons.keyboard-arrow-left  :refer [keyboard-arrow-left]]
            [reagent-material-ui.icons.check-box :refer [check-box]]
            [reagent-material-ui.icons.check-box-outline-blank :refer [check-box-outline-blank]]


            [reagent-material-ui.icons.delete-forever :refer [delete-forever]]
            [reagent-material-ui.icons.expand-more :refer [expand-more]]
            [reagent-material-ui.icons.expand-less :refer [expand-less]]
            [reagent-material-ui.icons.edit :refer [edit]]


            ))



(defn unParseDateFieldToTimestamp [ts]
  (if (and ts (> (count ts) 0))
    (str (subs ts 6 8) "." (subs ts 4 6) "." (subs ts 0 4) " " (subs ts 9 11) ":" (subs ts 11 13))
    "")
  ;(let [date (if ts (.toDate ts) (js/Date.))]  (goog.string.format "%04d-%02d-%02d %02d:%02d" (.getFullYear date) (inc (.getMonth date)) (.getDate date) (.getHours date) (.getMinutes date))    )
  )






(defn device-block [type name last-contact version]
  (let [name (if (= type "BROWSER") "" name)
        version (if (= type "BROWSER") "aktuell" version)]
    [mui/grid
     {:container false
      :item true
      :xs 12  ;extra-small: 0px
      :style {:padding "15px 15px 0 15px"}
      }
     [mui/card
      {:variant "outlined"}

      [mui/card-content {

                         }
       (case type
         "BROWSER" [:img { :src "/custom/img/browser.png" :style {:float "right" :width "60px"} :alt "Browser"}]
         "ANDROID" [:img { :src "/custom/img/android.png" :style {:float "right" :width "60px"} :alt "Android"}]
         "iOS" [:img { :src "/custom/img/apple.png" :style {:float "right" :width "60px"} :alt "Apple"}]
         [:span { :src "/custom/img/apple.png" :style {:float "right"} :alt "?"}])

       [mui/typography {:variant "body1" :gutterBottom true} type]
       [mui/typography {:variant "h6" :component "h6"} name]
       [:div
        [mui/typography {:variant "body1" :gutterBottom true}
         "Letzter Kontakt: " (unParseDateFieldToTimestamp last-contact)]
        [:div {:style {:display "inline_block" :float "right" :width "300px"}} "Version: " version " "] ]


       ]

      [mui/card-actions
       [mui/button {:size "small" :color "secondary"
                    :endIcon (r/as-element [delete-forever])
                    } "Löschen"] ]


      ]
     ]
    ))





(defn get-it [!actual-user !st]
  (let [!devices (r/cursor !actual-user [:user-devices])]
    (log/debug "################ :devices!! " @!devices)
    [mui/card {:style {:textAlign "left"}}
     [mui/card-header
      {:subheader "Mobil-Geräte"}]

     [mui/card-content
      (for [{:keys [device-type device-lastContact device-appVersion _device-pretty-phone-name]} (reverse (sort-by :device-lastContact @!devices))]
        ^{:key (str "device-" key)} [device-block device-type _device-pretty-phone-name device-lastContact device-appVersion]
        )]

     [mui/card-actions

      ]]))